import palette from "../palette";

export default {
    styleOverrides: {
        root: {
            textTransform: 'capitalize', 
          },
        text: {

        },
        contained: {
            fontSize: '16px' ,
            fontWeight: 500,
            padding: '2px 6px',
            width: '100%',
            '&:hover': {
              backgroundColor: palette.primary.main, 
            },
        },
        outlined: {
            fontSize: '16px' ,
            fontWeight: 500,
            padding: '2px 6px',
            width: '100%'
        }
      }
};